













































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IUser } from "@/models/users";
import StatsCurrencyMixin from "@/mixins/statsCurrencyMixin";
import { IsActiveParam } from "@/data/filters/contractProducts";
import { STATS_ALL_CURRENCY_CODE } from "@/data/constants";

@Component({
  components: {
    "recent-invoices-list": () =>
      import("@/components/app/global/invoices/recentInvoicesList.vue"),
    "recent-tickets-list": () =>
      import("@/components/app/global/tickets/recentTicketsList.vue"),
    "total-invoices-stat": () =>
      import("@/components/app/global/stats/invoicesTotal.vue"),
    "unpaid-invoices-stat": () =>
      import("@/components/app/global/stats/invoicesTotalUnpaid.vue"),
    "total-orders-stat": () =>
      import("@/components/app/global/stats/ordersTotal.vue"),
    "active-tickets-stat": () =>
      import("@/components/app/global/stats/ticketsOpen.vue"),
    "cprods-provider": () =>
      import("@/components/app/global/contractProducts/cProdsProvider.vue"),
    "cprod-well-link": () =>
      import("@/components/app/global/contractProducts/cProdWellLink.vue"),
    "cprods-onboarding": () =>
      import("@/components/app/global/contractProducts/cProdsOnboarding.vue")
  }
})
export default class AdminUpmindOverview extends Mixins(StatsCurrencyMixin) {
  // Props

  @Prop({ required: true })
  public readonly user!: IUser;

  // Data

  public currencyCode = STATS_ALL_CURRENCY_CODE;

  // Computed

  public get cProdFilters() {
    return IsActiveParam();
  }
}
